export default () =>
  import(/* webpackChunkName: 'coffee/mini/card-coupon/receive' */ './Receive');
